import useSize from "../../Utils/useSize/useSize";

export default function Loading({ height }) {
  const windowSize = useSize();

  return (
    <div
      className="bg-[var(--background)]"
      style={{
        height: height ? height : windowSize[1] - 70,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "opacity 0.4s ease-in-out",
      }}
    >
      {/* Logo */}
      <img
        src={window.LOGO}
        style={{
          width: 120,
          height: 120,
          marginBottom: 20,
          borderRadius: 10,
          animation: " pulse 1.5s infinite",
        }}
      />
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.2; }
          }
        `}
      </style>
    </div>
  );
}
